export function initMbSearch() {
  const searchBtn = document.getElementById("open-search");
  const searchBtnClose = document.getElementById("close-search");

  if (searchBtn != "undefined" && searchBtn != null) {
    searchBtn.addEventListener("click", function (event) {
      document
        .getElementById("searchform-container")
        .classList.add("show-search");
    });
  }
  if (searchBtnClose != "undefined" && searchBtnClose != null) {
    searchBtnClose.addEventListener("click", function (event) {
      document
        .getElementById("searchform-container")
        .classList.remove("show-search");
    });
  }
}
